function checkOverflowAll() {
  const scrollContainers = document.querySelectorAll('.js-card-colortip-scroll');

  scrollContainers.forEach((container, index) => {
    const isOverflowing = container.scrollWidth > container.clientWidth;
    if (isOverflowing) {
      container.classList.add('is-overflowing');
      const swiperContainer = container.closest('.js-card-colortip-swiper');
      if (swiperContainer) {
        const swiper = new Swiper(swiperContainer, {
          slidesPerView: 'auto',
          freeMode: true,
          loop: false,
          spaceBetween: 5,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded');
  checkOverflowAll();
  const colorTipItems = document.querySelectorAll('.js-card-colortip-item');
  colorTipItems.forEach(item => {
    item.addEventListener('click', () => {
      const productCardWrapper = item.closest('.product-card-wrapper');
      const productCardImage = productCardWrapper.querySelector('.media > img');
      const productCardSecondImage = productCardWrapper.querySelector('.media > img + img');
      productCardWrapper.querySelectorAll('.card__heading .full-unstyled-link').forEach(link => {
        link.href = item.dataset.url;
      });
      productCardImage.src = item.dataset.image;
      productCardImage.srcset = item.dataset.image;
      if (productCardSecondImage) {
        productCardSecondImage.src = item.dataset.image;
        productCardSecondImage.srcset = item.dataset.image;
      }
    });
  });
});
window.addEventListener('resize', () => {
  console.log('resize');
  checkOverflowAll();
});